import React, { useState, useContext, useEffect, useCallback } from "react";
import '../../../../lib/ui/imageicon/Styles.css';
import "../../../doctor/doctorProfile//doctorProfile.css";
import "../../../../ui-styles/filterList/filterInput.css";
import "../../../admin/reports/reports.css";

import Loader from "../../../../lib/ui/loader/Loader";
import { LangCtx } from "../../../../lib/context";
// import Button from "../../../../lib/ui/buttons/Button";
import ListDrugAlleg from "./ListDrugAlleg";
import AddAllergyInfo from "./AddAllergy";
import NoData from "../../../../lib/ui/nodata/NoData";
import { createPatientDrugAllegies, getPatientDrugAllegies, updatePatientDrugAllegies, deleteDrugAllergies } from "../../../../actions/appointment";
// import SaveIcon from '@material-ui/icons/Save';
// import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {API} from 'aws-amplify';

// const useStyles = makeStyles((theme) => ({
//   button: {
//     margin: theme.spacing(1),
//   },
// }));
const DrugAllergies = (props) => {
    const { l } = useContext(LangCtx);
    // const classes = useStyles();
    const [data, setData] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [openDrugAlleg, setOpenDrugAlleg] = useState(false);
    const [drugs, setDrugs] = useState([]);

    useEffect(() => {
        loadDrugs();
    }, []);

    const loadDrugs = () => {
        setLoading(true);
        getPatientDrugAllegies().then(res => {
            setLoading(false);
            if (res.status && res.data) {
                setDrugs(res.data)
                setData(null)
            }
        }).catch(err => {
            if(API.isCancel(err)) {
                console.log("API is canceled................");
            } else {
                setLoading(false);
            }
            console.log("err ==== ", err);
        })
    }

    const validate = (body) => {
        let _error = {};
        let returnValue = true;

        if (body.name === '' || body.name == null) {
            _error['drugName'] = l.pls_ent_name
            returnValue = false
        }

        if (body.description === '' || body.description == null) {
            _error['description'] = l.pls_ent_desc
            returnValue = false
        }


        setError(_error);
        return returnValue;
    }

    const handleAddDrug = (body) => {
        if (validate(body)) {
            setLoading(true);
            createPatientDrugAllegies(body).then(res => {
                setLoading(false);
                if (res.status && res.data) {
                    loadDrugs()
                    handleAllergyInfo()
                }
            }).catch(err => {
                let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.unable_upd_patient;
                setErrorMsg(msg)
                setLoading(false);
                console.log("err ==== ", err);
            })
        }
    }

    const handleUpdateDrug = useCallback((id, body) => {
        if (validate(body)) {
            setLoading(true);
            updatePatientDrugAllegies(id, body).then(res => {
                setLoading(false);
                if (res.status && res.data) {
                    loadDrugs()
                    handleAllergyInfo()
                }
            }).catch(err => {
                let msg = err?.response?.data?.error ? err.response.data.error : err.errorMessage ? err.errorMessage : l.unable_upd_patient;
                setErrorMsg(msg)
                setLoading(false);
                console.log("err ==== ", err);
            })
        }
    }, [])

    const handleDeleteDrug = useCallback((id) => {
        setLoading(true);
        // deletePatientDrugAllegies(id).then(res => {
        //     setLoading(false);
        //     if (res.status && res.data) {
        //         loadDrugs();
        //     }
        // }).catch(err => {
        //     setLoading(false);
        //     console.log("err ==== ", err);
        // })
        let data = {
            id: id
        }
        deleteDrugAllergies(data).then(res => {
            setLoading(false);
            if (res.status && res.data) {
                loadDrugs();
            }
        }).catch(err => {
            setLoading(false);
            console.log("err ==== ", err);
        })
    }, [])

    const handleAllergyInfo = () => {
        setData(null)
        setError({});
        setOpenDrugAlleg(prevState => !prevState);
    }
    const handleEdit = useCallback((data) => {
        setData(data);
        setOpenDrugAlleg(prevState => !prevState);
    }, []);
    return (
        <div className="">
            <div className="listActionBlock">
                {/* <div className="invHdngTopCol">
                    <AddAllergyInfo openAllergy={openDrugAlleg} closeDrugAlleg={handleAllergyInfo} />
                </div> 
                <div className="searchCntnr">
                    <div className="searchBox">
                        <div className="searchForm">
                            <input className="textbox" type="text" placeholder={l.plc_search}
                                value={query}
                                onChange={(e) => setQuery(e.target.value)} />
                        </div>
                    </div>
                </div>*/}
                <div className="rowBlock mrgTop16">
                    <div className="btnTxtGroup flxEnd mrgRight16">
                        {(drugs && drugs.length > 0) &&
                        <>
                            {/* <Button size="sm" className="btn" type="outLine" onClick={handleAllergyInfo}
                                label={
                                    <div className="alignCenter">
                                        <span className="btnPlus">{l.add_anthr}</span>
                                    </div>} /> */}
                            <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className='whiteTxt'
                            disableElevation
                            disableFocusRipple
                            disableTouchRipple
                            onClick={handleAllergyInfo}
                            startIcon={<AddIcon />}
                          >
                             {l.add_anthr}
                          </Button>
                          </>
                        }

                    </div>
                </div>
                {/* <div className="inlineItemContainer">
                    <div className="inlineItemGroup">
                        <Button size="sm" className="btn" type="outLine" onClick={handleAllergyInfo}
                            label={
                                <div className="alignCenter">
                                    <span className="btnPlus">{l.add_anthr}</span>
                                </div>} />
                    </div>
                </div> */}
            </div>
            { /* <div className="rprtAtnRow">
             <div className="halfRow makeFull">
                    <span className="spanTxt">{l.show} {clinics.length + '/' + display}</span>
                    <DropDownSm
                        placeholder="10"
                        items={drop}
                        value={display}
                        onChange={(e) => { setDisplay(e.target.value); }}
                        size="smallSize"
                    />
                </div>
                <div className="halfRow">
                    <div className="prevNxtBox">
                        <div className="prevBtn" disabled={!prevButton} >
                            <span className={prevButton ? "activeTxt active" : "activeTxt inactive"} >{l.previous}</span>
                        </div>
                        <div className="nxtBtn" disabled={!nextButton}>
                            <span className={nextButton ? "activeTxt active" : "activeTxt inactive"} > {l.next}</span>
                        </div>
                    </div>
                </div>
                            </div> */}
            <div className="colBlock nopdng">
                <ul className="cntcListGroup">
                    {/* {loading && <Loader />} */}
                    {/* {drugs.map((drugItem, index) => <ListDrugAlleg key={`${drugItem.name}_${index}`} drugItem={drugItem} delete={handleDeleteDrug} editDrug={handleUpdateDrug} handleEdit={handleEdit} />)} */}


                    {loading ? <Loader /> : drugs && drugs.length > 0 ? drugs.map(drugItem => (
                        <ListDrugAlleg key={drugItem.name} drugItem={drugItem} delete={handleDeleteDrug} editDrug={handleUpdateDrug} handleEdit={handleEdit} />
                    )) : <NoData src="/images/icons/tablets-new.png" Heading={l.no_drug_allergy} label={l.no_drug_allergy_desc} btnAction="true" btnLabel={l.add_allergy} handleButton={handleAllergyInfo} />
                    }


                </ul>
            </div>
            {openDrugAlleg && <AddAllergyInfo openAllergy={openDrugAlleg} data={data} errorMsg={errorMsg} error={error} closeDrugAlleg={handleAllergyInfo} addDrug={handleAddDrug} editDrug={handleUpdateDrug} />}
        </div>
    )
}
export default DrugAllergies;
